const HotArticle = () => {
  return <div>HotArticle</div>;
};

export default HotArticle;
